import React from 'react';
import './style.scss';
import finalBannerHero from '../../../images/final-banner-image.png'
import { telegramMock } from 'telegram.consts';

export const FinalBanner = () => {
    return <div className="app-final-banner" onClick={() => {
        const webApp = window.Telegram.WebApp;
        webApp.openTelegramLink('https://t.me/tv3russia');
    }}>
        <img src={finalBannerHero} alt="" className="app-final-banner--image"/>
        <div className="app-final-banner--content">
            <div className="app-final-banner--title">Оставайся с нами!</div>
            <div className="app-final-banner--description">
            Совсем скоро расскажем новости <br/> о 6-м сезоне. Следи за нашим <a>каналом</a>! 🐞😉
            </div>
        </div>
    </div>;
}